<template>
  <div class="section premium-dorm">
    <container>
      <div class="premium-dorm__inner">
        <div class="premium-dorm__cnt">
          <div class="section__title" style="text-align: left;width: 100%;margin-bottom: 35px;border-bottom: 1px solid #d7ddea;
    padding-bottom: 19px;">
            <span class="color-light-green">Yurtlar Burada</span> Blog
          </div>
          <div v-if="settings">
            <div class="premium-dorm__title">
              {{ settings.setting.blog_section_title }}
            </div>
            <div class="premium-dorm__txt cropDesktop">
              {{ settings.setting.blog_section_description}}
            </div>

            <div class="premium-dorm__txt cropMobile">
              {{ settings.setting.blog_section_description | truncate(150) }}
            </div>
          </div>
          <v-link
            class="button--more color-purple"
            title="Tüm Yazılar"
            icon="icon-arrow-long-right"
            icon-position="right"
            :to="{ name: 'Blog' }"
          />
        </div>
        <div class="premium-dorm-slider desktopBlog">
          <BlogCard :blog="blog" v-for="blog in blogs" :key="blog.id"/>
        </div>

        <swiper :options="swiperOption" class="mobileBlog">
          <swiper-slide
            v-for="blog in blogs"
            :key="blog.id"
            class="featured-dorms__col col-xl-3 col-lg-3 col-md-4">
            <BlogCard
              :blog="blog"
            />
          </swiper-slide>
          <div class="swiper-pagination" style="text-align: center;" slot="pagination"></div>
        </swiper>

      </div>
    </container>
  </div>
</template>

<script>
import BlogCard from '@/components/Blog/BlogCard'
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'BlogSection',
  props: {
    blog: Object
  },
  components: {
    BlogCard
  },
  data () {
    return {
      blogs: [],
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 20,
        breakpoints: {
          768: {
            slidesPerView: 2
          },
          640: {
            slidesPerView: 1
          },
          320: {
            slidesPerView: 1
          }
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  methods: {
    getBlogs () {
      let self = this
       axios.get('/site/home/blogs')
        .then(response => {
          let blogs = response.data.sort(function(a, b) {
          return a.created_at - b.created_at;
          })
          // 2019-03-29 07:20:57
          self.blogs.push(blogs[0])
          if(blogs[1]) {
            self.blogs.push(blogs[1])
          }
          if(blogs[2]) {
          self.blogs.push(blogs[2])
          }
        })
        .catch(e => {
          this.errors.push(e)
        })
    }
  },
  computed: {
    ...mapGetters(['settings'])
  },
  created () {
    this.getBlogs()
  }
}
</script>

<style lang="scss" >
  @import "../../assets/scss/components/premium-dorm";

  .premium-dorm-slider {
    position: relative;
    left: 25px;
    @media screen and (max-width: 1000px){
      &:before{
        display: none;
      }
      left: 15px;
      padding-left: 0px;

    }

    .blog-card {
      width: 31%;
      margin-right: 19px;
      /*height: 360px;*/
      @media screen and (max-width: 1000px){
        margin-right: 13px;
        .blog-card-inf__icon{
          font-size: 17px;
          margin-right: 10px;
        }
        .blog-card__date{
          font-size: 13px;
        }
        .blog-card-inf__title{
          font-size: 13px;
        }
        .blog-card__cnt{
          padding: 15px;
        }
        .blog-card__title{
          font-size: 13px;
        }
      }

      &:last-child {
        margin-right: 0;
      }
      &__top {
        height: 163px;
      }
    }
  }
</style>
